export default __webpack_public_path__ + "static/howItWorksCard2-f8c37b455e244d227e5c23cd9b8e6ea1.png";